module.exports = __webpack_public_path__ + "static/img/comments_icon.f860314.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comments_icon.jpg
// module id = 5UcJ
// module chunks = 10